import { Modal } from "react-bootstrap";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const ResolveTicket = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [inputError, setInputError] = useState([]);
  const remarkInputRef = useRef();
  const [showConfirm, setShowConfirm] = useState(false);
  const [resolveData, setResolveData] = useState({
    ROOT_CAUSE: "",
    SOLUTION: "",
    REMARK: "",
    ATTACHMENT: "",
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [columns, setColumns] = useState([]);
  var emptyFile = { name: " ", size: " " }
  const fileData = [...selectedFiles, emptyFile]
  const message = (
    <>
      Confirm to Resolve?
      <br />
      Ticket Num:
      {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}
    </>
  );

  const SendEmail = (_data) => { 
    let functionName = "onSaveConfirmHandler";

    try {
        props.onLoading(true, "Sending email, please wait...");
        const data = {
            TICKET_MST_ID: _data.TICKET_MST_ID,
            TICKET_NUM: _data.TICKET_NUM, 
            ORG_ID: _data.ORG_ID,   
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            UPDATE_ID: userId,
        };
        http
            .post("api/Ticket/SendResolveEmail", data, { timeout: common.DEFAULT_TIMEOUT })
            .then((response) => {
              props.onLoading(true, "Sending email...");
            })
            .catch((err) => {    
                common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
                props.onLoading(false, "Loading...");
            })


    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send");
        common.c_LogWebError(props.page, functionName, err);
    }
  };

  const ResolveBtnOnClick = () => {
    var flag = true;
    if (
    resolveData.ROOT_CAUSE === undefined ||
    Object.keys(resolveData.ROOT_CAUSE).length === 0
  ) {
    flag = false;
    setInputError((prevState) => ({
      ...prevState,
      ROOT_CAUSE: "Please fill in root cause.",
    }));
  } else {
    setInputError((prevState) => ({
      ...prevState,
      ROOT_CAUSE: "",
    }));
  }
  if (
    resolveData.SOLUTION === undefined ||
    Object.keys(resolveData.SOLUTION).length === 0
  ) {
    flag = false;
    setInputError((prevState) => ({
      ...prevState,
      SOLUTION: "Please fill in solutions.",
    }));
  } else {
    setInputError((prevState) => ({
      ...prevState,
      SOLUTION: "",
    }));
    }
    if (flag) {
      ResolveTicket(props.viewData);
    }
  }

  function ResolveTicket(_data) {
    let functionName = "";
    try {
      functionName = "Resolve Ticket";

      props.onLoading(true, "Resolving ticket, please wait...");

    
      const fileArr = [...selectedFiles];
      const formData = new FormData();
      fileArr.forEach((file) => {
          formData.append("file", file);
      });

       http
          .post(common.c_getApiUrl() + "api/ticket/ResolveTicket", formData, {
              headers: {
                  
                  "Content-Type": "multipart/form-data",
                  TICKET_MST_ID: _data.TICKET_MST_ID,
                  TICKET_NUM: _data.TICKET_NUM,
                  TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS_TYPE_ID,
                  TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS_TYPE_NAME,
                  UPDATE_DATETIME: _data.UPDATE_DATETIME,
                  TICKET_RESOLVE_DETAILS: JSON.stringify({
                    ROOT_CAUSE: resolveData.ROOT_CAUSE,
                    SOLUTION: resolveData.SOLUTION,
                    REMARK: resolveData.REMARK,
                    FILE_COUNT: selectedFiles.length,
                  }),
                  RESOLVED_BY: userId
              },
          })
          .then((response) => {
            if (response.data.OPEN_STATUS === false) {
              if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
                toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
              } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
                toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
              } else if (response.data.TICKET_STATUS_TYPE_NAME === "RESOLVE") {
                toast.error("Ticket " + response.data.TICKET_NUM + " has been resolved." );   
              }                
              props.onReload();
              hideModal();
            }
            else {
              toast.success("Ticket is successfully resolved.");
              SendEmail(_data);
              props.onReload();
              hideModal();
            }     
          })
          .catch((err) => {
            toast.error("Failed to resolve ticket. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
     
    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to resolve ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
    }
  }
  
  const hideModal = () => {
    setResolveData([]);
    setInputError([]);
    setSelectedFiles([]);
    props.onHide();
  };
    
  const hideConfirmModal = () => {
    setShowConfirm(!showConfirm);
  };
  
  const showConfirmModal = () => {
    setShowConfirm(!showConfirm);
  }
  useEffect(() => {
    setColumns([
        {
            accessorFn: (row) => row.name,
            header: "Filename",
            size: "60",
        },
        {
            accessorFn: (row) => row.size === " " ? " " : formatSize(row.size),
            header: "Size",
            size: "10",
        },
        {
            id: "Action",
            header: "Action",
            size: "10",
            accessorFn: (row) => (
                <div>
                    {row.name !== " "
                        ? <span>
                            <button
                                style={{
                                    backgroundColor: "white",
                                    border: "none",
                                    alignItems: "center",
                                }}
                                onClick={(e) => clearFiles(e, row)}
                            >
                                <CloseRoundedIcon />
                            </button>
                        </span>
                        : <span>
                            <button
                                style={{
                                    backgroundColor: "white",
                                    border: "none",
                                }}
                                onClick={chooseFileFn}
                            >
                                <AddRoundedIcon />
                            </button>
                        </span>}
                </div>
            ),
        }
    ])
  }, [selectedFiles])
  
  const clearFiles = (e, row) => {
    const newData = [...selectedFiles];

    for (let i = 0; i < newData.length; i++) {

        if (newData[i] === row) {
            newData.splice(i, 1);
        }
    }
    setSelectedFiles(newData);
}

function chooseFileFn() {
    document.getElementById("ATTACHMENT").click();
}

const formatSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setResolveData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setResolveData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  const selectFileHandler = (event) => {
      let functionName = "";

      try {
          functionName = selectFileHandler.name;
          const files = event.target.files;

          if (files.length === 0) {
              setSelectedFiles([]);
              setInputError((prevState) => ({
                  ...prevState,
                  ATTACHMENT: "",
              }));
          } else {
              for (let i = 0; i < files.length; i++) {
                  if (files[i].size <= 4 * 1024 * 1024) {
                      if (selectedFiles.some(file => file.name === files[i].name)) {
                          setInputError((prevState) => ({
                              ...prevState,
                              ATTACHMENT:
                                  files[i].name + " has already exist",
                          }));
                          toast.error(files[i].name + " has already exist");
                      }
                      else {
                          selectedFiles.push(files[i]);
                          setResolveData((prevState) => ({
                              ...prevState,
                              ATTACHMENT: selectedFiles,
                          }));
                          setInputError((prevState) => ({
                              ...prevState,
                              ATTACHMENT: "",
                          }));
                      }
                  } else {
                      setInputError((prevState) => ({
                          ...prevState,
                          ATTACHMENT:
                              "Attachment file could not be exceeds 4MB size limit.",
                      }));
                      toast.error(files[i].name + " exceeds 4MB size limit");
                  }
              }

              event.target.value = null;

              setInputError((prevState) => ({
                  ...prevState,
                  ATTACHMENT: "",
              }));
          }
      } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
      }
  };

  return (
    <> <Modal show={props.showHide} onHide={props.onHide} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%", textAlign: "center" }}>
            <Modal.Title>Resolve Ticket</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
        
          <Comp.TextArea
            ref={remarkInputRef}
            id="ROOT_CAUSE"
            type="text"
            name= "Root Cause"
            className="form-control"
            value={resolveData.ROOT_CAUSE}
            label = "Root Cause:"
            errorMessage={inputError.ROOT_CAUSE}
            onChange={inputRequiredHandler}
          />     

          <Comp.TextArea
            ref={remarkInputRef}
            id="SOLUTION"
            type="text"
            name= "Solutions"
            className="form-control"
            value={resolveData.SOLUTION}
            label = "Solutions:"
            errorMessage={inputError.SOLUTION}
            onChange={inputRequiredHandler}
          />     
  
          <Comp.TextArea
            ref={remarkInputRef}
            id="REMARK"
            name= "Remark"
            type="text"
            className="form-control"
            value={resolveData.REMARK}
            label = "Remark:"
            errorMessage={inputError.REMARK}
            onChange={inputUnrequiredHandler}
        />
        
          <Comp.Input
            id="ATTACHMENT"
            type="file"
            className="form-control"
            label="Upload File (Max. File Size 4MB):"
            name="Upload File"
            value={resolveData.ATTACHMENT}
            onChange={selectFileHandler}
            accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png"
            errorMessage={inputError.ATTACHMENT}
            hidden={true}
          multiple
          
        />  
        <br></br>
      <label>Upload File (Max.File Size 4MB per file)</label>
      <br></br>
        <Comp.Table data={fileData} columns={columns} enableTopToolbar={false}/> 
        <br></br>
        
        <label>{selectedFiles == null ? 0 : selectedFiles.length } File(s) Selected</label>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
          <Comp.Button type="general" onClick={ResolveBtnOnClick}>
            Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
          </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
            Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
          </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

        <Comp.ConfirmModal
          show={showConfirm}
          onHide={hideConfirmModal}
          onConfirm={ResolveBtnOnClick}
        >
          {message}
        </Comp.ConfirmModal>
      </>
  );
}

export default ResolveTicket;